
export function labelDesignBaseSetting(Vue, options) {


    Vue.prototype._graphBaseSetLabel = function (self, mxClient, mxUtils, mxConstants, mxPerimeter) {

        self.m_editor.setGraphContainer(self.m_graphContainer);
        var config = mxUtils
            .load("/script/mxgraph-source/config/keyhandler-commons.xml") //本来想将这个文件打包到项目里面去的，但是webpack对xml类型的静态文件处理方式，也是直接拷贝的，因此，目前想放到配置文件夹中
            .getDocumentElement();
        self.m_editor.configure(config);
        mxEditor.prototype.swimlaneRequired = true;
        self.m_graph.setMultigraph(true); //允许多个连接
        self.m_graph.setPanning(true); //激活右键移动画布
        self.m_graph.getView().updateStyle = true; //允许动态改变样式
        self.m_graph.setCellsEditable(true);
        mxGraph.prototype.foldingEnabled = false;

        self.m_graph.setTooltips(false);
        self.m_graph.setAllowLoops(false); //不允许自己连自己
        if (self.m_graph.isEnabled()) {
            //页面没有禁用的时候，可以响应这些事件
            new mxKeyHandler(self.m_graph); //启用键盘事件\
            new mxRubberband(self.m_graph); //鼠标框选
        }
        self.m_graph.setHtmlLabels(true);
        // 拖拽过程对齐线
        mxGraphHandler.prototype.guidesEnabled = true;
        // 禁止游离线条
        self.m_graph.setDisconnectOnMove(false);
        self.m_graph.setAllowDanglingEdges(false);
        this._initLeftMenuLabel(self, mxUtils);
        this.configureStylesheet(self.m_graph, mxConstants, mxPerimeter); //初始化元素样式
    };
    Vue.prototype._initLeftMenuLabel = function (self, mxUtils) {
        this.addVerteLabel(
            self,
            mxUtils,
            "Rectangle",
            "矩形",
            require("../../assets/mxgraph-source/images/images/rectangle.gif"),
            100,
            40,
            "shape=Rectangle;verticalAlign=top;align=left;overflow=fill;fontSize=12;fontFamily=Helvetica;whiteSpace=wrap"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "rounded",
            "圆形",
            require("../../assets/mxgraph-source/images/images/rounded.gif"),
            100,
            40,
            "shape=Rounded Rectangle;rounded=1;whiteSpace=wrap;html=1;"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "ellipse",
            "椭圆",
            require("../../assets/mxgraph-source/images/images/ellipse.gif"),
            40,
            40,
            "shape=ellipse;whiteSpace=wrap;html=1;"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "triangle",
            "三角形",
            require("../../assets/mxgraph-source/images/images/triangle.gif"),
            40,
            40,
            "shape=triangle"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "doubleellipse",
            "同心圆",
            require("../../assets/mxgraph-source/images/images/doubleellipse.gif"),
            40,
            40,
            "shape=doubleEllipse;perimeter=ellipsePerimeter;"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "image",
            "图片",
            require("../../assets/mxgraph-source/images/images/image.gif"),
            80,
            80,
            "shape=image;image=" + this.getProfileBaseUrlInfo() + "mxgraph-source/images/images/draw/mxlogo.jpg"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "text",
            "文本",
            require("../../assets/mxgraph-source/images/images/text.gif"),
            100,
            40,
            "text;strokeColor=none;fillColor=none;html=1;fontSize=12;fontStyle=0;verticalAlign=middle;align=center;fontFamily=Helvetica"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "fx",
            "变量",
            require("../../assets/mxgraph-source/images/images/变量.png"),
            124,
            90,
            "text;strokeColor=none;fillColor=none;html=1;fontSize=12;fontStyle=0;verticalAlign=middle;align=center;"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "cylinder",
            "圆柱体",
            require("../../assets/mxgraph-source/images/images/cylinder.gif"),
            40,
            40,
            "shape=cylinder"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "actor",
            "立体图形",
            require("../../assets/mxgraph-source/images/images/actor.gif"),
            30,
            40,
            "shape=actor"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "cloud",
            "云",
            require("../../assets/mxgraph-source/images/images/cloud.gif"),
            30,
            40,
            "shape=ellipse;shape=cloud;whiteSpace=wrap;html=1;"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "line",
            "直线",
            require("../../assets/mxgraph-source/images/images/straight.gif"),
            200,
            6,
            "shape=line;"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "qrCode",
            "二维码",
            require("../../assets/mxgraph-source/images/images/二维码.png"),
            116,
            116,
            "shape=Rectangle;verticalAlign=top;align=left;overflow=fill;whiteSpace=wrap;strokeColor=none"
        );
        this.addVerteLabel(
            self,
            mxUtils,
            "barCode",
            "一维码",
            require("../../assets/mxgraph-source/images/images/一维码.png"),
            124,
            90,
            "shape=Rectangle;verticalAlign=top;align=left;overflow=fill;fontSize=12;fontFamily=Helvetica;whiteSpace=wrap;strokeColor=none"
        );
    };
    Vue.prototype.addVerteLabel = function (self, mxUtils, id, title, icon, w, h, style, shape) {
        var vertex = new mxCell(null, new mxGeometry(0, 0, w, h), style);
        vertex.cellType = id;
        vertex.setVertex(true);
        vertex.enabled = false;
        self.addToolbarItemLabel(self, mxUtils, self.m_graph, self.m_toolbar, vertex, icon, title);
    };
    Vue.prototype.addToolbarItemLabel = function (self, mxUtils, graph, toolbar, prototype, image, title) {
        // Function that is executed when the image is dropped on
        // the graph. The cell argument points to the cell under
        // the mousepointer if there is one.
        var funct = function (graph, evt, cell) {
            graph.stopEditing(true);
            self.drawByIdLabel(self, prototype, graph, evt, cell);
        };
        // Creates the image which is used as the drag icon (preview)
        var img = toolbar.addMode(title, image, funct); //绑定图标的响应函数
        mxUtils.makeDraggable(img, graph, funct);
    }

    Vue.prototype.configureStylesheet = function (graph, mxConstants, mxPerimeter) {
        //设置矩形样式
        var style = new Object();
        style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_RECTANGLE;
        style[mxConstants.STYLE_PERIMETER] = mxPerimeter.RectanglePerimeter;
        style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_LABEL;
        style[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_CENTER;
        style[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE;
        style[mxConstants.STYLE_GRADIENTCOLOR] = "#ffffff";
        style[mxConstants.STYLE_FILLCOLOR] = "#ffffff";
        style[mxConstants.STYLE_STROKECOLOR] = "#000000"; //"#1B78C8"
        style[mxConstants.STYLE_FONTCOLOR] = "#000000";
        style[mxConstants.STYLE_ROUNDED] = false;
        style[mxConstants.STYLE_OPACITY] = "80";
        style[mxConstants.STYLE_FONTSIZE] = "6";
        style[mxConstants.STYLE_FONTSTYLE] = 0;
        style[mxConstants.STYLE_IMAGE_WIDTH] = "48";
        style[mxConstants.STYLE_IMAGE_HEIGHT] = "48";
        graph.getStylesheet().putDefaultVertexStyle(style);

        //设置泳道样式
        style = new Object();
        style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_SWIMLANE;
        style[mxConstants.STYLE_PERIMETER] = mxPerimeter.RectanglePerimeter;
        style[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_CENTER;
        style[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_TOP;
        style[mxConstants.STYLE_FONTCOLOR] = "#000000";
        style[mxConstants.STYLE_ROUNDED] = true;
        style[mxConstants.STYLE_OPACITY] = "80";
        style[mxConstants.STYLE_STARTSIZE] = "1";
        style[mxConstants.STYLE_FONTSIZE] = "16";
        style[mxConstants.STYLE_FONTSTYLE] = 1;
        style[mxConstants.STYLE_DASHED] = 1;
        style[mxConstants.STYLE_SWIMLANE_LINE] = 0;
        graph.getStylesheet().putCellStyle('swimlaneInner', style);


        //设置图片样式
        var style = new Object();
        style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_IMAGE;
        style[mxConstants.STYLE_PERIMETER] = mxPerimeter.RectanglePerimeter;
        style[mxConstants.STYLE_IMAGE] = '/script/mxgraph-source/images/images/draw/mxlogo.jpg';
        style[mxConstants.STYLE_FONTCOLOR] = '#FFFFFF';
        graph.getStylesheet().putCellStyle('image', style);

    };
    Vue.prototype.drawByIdLabel = function (self, prototype, graph, evt, cell) {
        var pt = this.m_graph.getPointForEvent(evt);
        var vertex = graph.getModel().cloneCell(prototype);
        vertex.geometry.x = pt.x;
        vertex.geometry.y = pt.y;
        switch (vertex.cellType) {
            case "text": {
                vertex.setValue("文本");
                break;
            }
            case "fx": {
                vertex.setValue("变量");
                break;
            }
            case "qrCode": {
                vertex.setValue('<img src=' + this.qrCodeUrl + '>');
                vertex.codeType = "QR"
                vertex.ifFixText = false

                break;
            }
            case "barCode": {
                vertex.setValue('<img src=' + this.barCodeUrl + '>');
                vertex.codeType = 'CODE128';
                vertex.ifFixText = false
                break;
            }
        }
        graph.setSelectionCells(graph.importCells([vertex], 0, 0, cell));
        graph.refresh();

    };
    //获取系统dpi
    Vue.prototype.conversion_getDPI = function () {
        var arrDPI = new Array;
        if (window.screen.deviceXDPI) {
            arrDPI[0] = window.screen.deviceXDPI;
            arrDPI[1] = window.screen.deviceYDPI;
        } else {
            var tmpNode = document.createElement("DIV");
            tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
            document.body.appendChild(tmpNode);
            arrDPI[0] = parseInt(tmpNode.offsetWidth);
            arrDPI[1] = parseInt(tmpNode.offsetHeight);
            tmpNode.parentNode.removeChild(tmpNode);
        }
        return arrDPI;
    };

    //将px转换成mm
    Vue.prototype.pxConversionMm = function (value) {
        var inch = value / this.conversion_getDPI()[0];
        var c_value = inch * 25.4;
        //      console.log(c_value);
        return c_value;
    };
    //将mm转换成px
    Vue.prototype.mmConversionPx = function (value) {
        var inch = value / 25.4;
        var c_value = inch * this.conversion_getDPI()[0];
        //      console.log(c_value);
        return c_value;
    }
}

export default labelDesignBaseSetting